export enum LdTabs {
  Kpi = 'kpi',
  Correlations = 'correlations',
  LoggerNoise = 'loggerNoise',
  Events = 'events',
}
